/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TrackSurface = {
    hub_page: 'hub_page',
    quest_card: 'quest_card',
    competition_page: 'competition_page',
    cockpit: 'cockpit',
    loot_shop: 'loot_shop',
    activation_card: 'activation_card',
    activation_card_complete: 'activation_card_complete',
    activation_card_claimed: 'activation_card_claimed',
    activation_card_capped: 'activation_card_capped',
    admin: 'admin',
    drop_in_directory: 'drop_in_directory',
    drop_in_directory_card: 'drop_in_directory_card',
    drop_page: 'drop_page',
    drop_in_filter: 'drop_in_filter',
    drop_in_section: 'drop_in_section',
    drop_in_storefront: 'drop_in_storefront',
    partner_embed: 'partner_embed'
} as const;
export type TrackSurface = typeof TrackSurface[keyof typeof TrackSurface];


export function instanceOfTrackSurface(value: any): boolean {
    for (const key in TrackSurface) {
        if (Object.prototype.hasOwnProperty.call(TrackSurface, key)) {
            if (TrackSurface[key as keyof typeof TrackSurface] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TrackSurfaceFromJSON(json: any): TrackSurface {
    return TrackSurfaceFromJSONTyped(json, false);
}

export function TrackSurfaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackSurface {
    return json as TrackSurface;
}

export function TrackSurfaceToJSON(value?: TrackSurface | null): any {
    return value as any;
}

export function TrackSurfaceToJSONTyped(value: any, ignoreDiscriminator: boolean): TrackSurface {
    return value as TrackSurface;
}

